import { TextArea } from "@src/components/deprecated/TextArea/TextArea";
import { TextInputField } from "@src/components/deprecated/TextInputField/TextInputField";
import TranslationDataEditor from "@src/components/deprecated/TranslationDataEditor/TranslationDataEditor";
import { t } from "i18next";
import { DataObjectFieldComparator } from "../../DataObjects/DataObjectFieldComparator";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { TranslationData } from "../../TranslationData";
import { DataObjectField, DecodeStringContext, InputElementContext } from "../DataObjectField";
import styles from "../DataObjectField.module.css";

export class FirebaseDataStringField<FirebaseDataType extends DataObjectType> extends DataObjectField<string, FirebaseDataType> {
  useTextArea: boolean;

  constructor(
    key: string,
    title: string,
    dataGetter: (data: FirebaseDataType) => string | string[] | undefined,
    iconName?: string,
    isArray: boolean = false,
    useTextArea: boolean = false
  ) {
    super(key, title, dataGetter, iconName, isArray);
    this.useTextArea = useTextArea;
  }

  equalComparator = (a: string | undefined, b: string | undefined) => {
    return a?.toLowerCase?.() === b?.toLowerCase?.();
  };
  includesComparator = (a: unknown, b: unknown) => {
    if (typeof a !== "string" || typeof b !== "string") return false;
    return a.toLowerCase().includes(b.toLowerCase());
  };

  override singleInputElement = (value: string | undefined, setValue: (value: string | undefined) => void, context?: InputElementContext) => {
    return this.useTextArea ? (
      <TextArea
        width={context?.width}
        height={context?.height}
        className={styles.textArea}
        value={value ?? ""}
        placeholder={t("main.fillInAText")}
        onChange={(text) => setValue(text)}
        disabled={context?.disabled}
      />
    ) : (
      <TextInputField
        width={context?.width}
        height={context?.height}
        className={styles.textField}
        value={value}
        placeholder={t("main.fillInAText")}
        onChange={(text) => setValue(text)}
        disabled={context?.disabled}
        dataCy={context?.dataCy}
      />
    );
  };

  getReadableStringRepresentation(value: string): string {
    return value;
  }

  encodeString = (value: string) => value;
  decodeString = (value: string) => value;

  encode = (value: string) => value;
  decode = (value: any) => (typeof value === "string" ? value : undefined);

  allComparators: DataObjectFieldComparator[] = ["includes", "equals", "not-equals", "is-known", "is-unknown"];
  override isValueValid = (value: any): boolean => {
    return typeof value === "string";
  };
}
export class FirebaseDataTranslationDataField<FirebaseDataType extends DataObjectType> extends DataObjectField<TranslationData, FirebaseDataType> {
  useTextArea: boolean;

  constructor(
    key: string,
    title: string,
    dataGetter: (data: FirebaseDataType) => TranslationData | TranslationData[] | undefined,
    iconName?: string,
    isArray: boolean = false,
    useTextArea: boolean = false
  ) {
    super(key, title, dataGetter, iconName, isArray);
    this.useTextArea = useTextArea;
  }

  encodeString = (value: TranslationData) => {
    return value.translate();
  };
  decodeString = (value: string, context?: DecodeStringContext | undefined) => {
    return TranslationData.getTranslationData(value);
  };
  encode = (value: TranslationData) => {
    return this.encodeString(value);
  };
  decode = (value: any) => {
    if (value instanceof TranslationData) return value;
    return this.decodeString(value);
  };

  equalComparator = (a: TranslationData | undefined, b: TranslationData | undefined) => {
    return a?.translate?.().toLowerCase() === b?.translate?.().toLowerCase();
  };
  includesComparator = (a: TranslationData, b: TranslationData) => {
    return a.translate().toLowerCase().includes(b.translate().toLowerCase());
  };

  override singleInputElement = (
    value: TranslationData | undefined,
    setValue: (value: TranslationData | undefined) => void,
    context?: InputElementContext
  ) => (
    <TranslationDataEditor
      data={value}
      inputType={this.useTextArea ? "textarea" : "input"}
      onNameChange={(_, text) => setValue(TranslationData.getTranslationData(text))}
    />
  );

  getReadableStringRepresentation(value: TranslationData): string {
    return value.translate();
  }
  allComparators: DataObjectFieldComparator[] = ["includes", "equals", "not-equals", "is-known", "is-unknown"];
  override isValueValid = (value: any): boolean => {
    return value instanceof TranslationData;
  };
}
